module.exports = __webpack_public_path__ + "static/media/cenz.0a790117.svg";